import { render, staticRenderFns } from "./CategoryControl.vue?vue&type=template&id=66ba76fc&scoped=true&"
import script from "./CategoryControl.vue?vue&type=script&lang=js&"
export * from "./CategoryControl.vue?vue&type=script&lang=js&"
import style0 from "./CategoryControl.vue?vue&type=style&index=0&id=66ba76fc&scoped=true&lang=scss&"
import style1 from "./CategoryControl.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba76fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDialog,VPagination})
